export default __webpack_public_path__ + "static/media/logo.92b66261.png";